var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKibanaSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-43 0 342 342",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,306.929431 L0,340.94153 L15.9856864,340.94153 L156.319606,172.717689 C146.588635,166.392997 136.454031,160.712166 125.980814,155.71164 L0,306.929431 Z",
    fill: "#009B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.32414,172.717689 L15.9221957,341.009554 L255.571444,341.009554 C255.571444,272.441163 216.661603,211.491482 156.32414,172.717689 Z",
    fill: "#40BEB0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EF5098",
    points: "-5.24025268e-14 0 -1.27897692e-13 307.445368 256 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0681886504,307.339209 L126.243164,155.845133 C86.6932342,137.371934 43.6510777,127.804446 0,128.003058 L0.0681886504,307.339209 Z",
    fill: "#353535"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKibanaSvgrepoCom);
export default __webpack_public_path__ + "static/media/kibana-svgrepo-com.a636555a0a142a52891adf90c825e668.svg";
export { ForwardRef as ReactComponent };